export const TINYMCE_BASE_URL = '/tinymce';
export const TINYMCE_SCRIPT_SRC = `${TINYMCE_BASE_URL}/tinymce.min.js`;
